import FormsAuthenticator from './Authenticators/FormsAuthenticator';
import GatewayAuthenticator from './Authenticators/GatewayAuthenticator';
import IntegratedWindowsAuthenticator from './Authenticators/IntegratedWindowsAuthenticator';
import CertificateAuthenticator from './Authenticators/CertificateAuthenticator';
import HttpBasicAuthenticator from './Authenticators/HttpBasicAuthenticator';
import { Authenticator } from './Authenticators/Authenticator';
import { Protocol } from '../AuthConfig';

export function getAuthenticator(protocol: Protocol): Authenticator {
	if (protocol === Protocol.IntegratedWindows) {
		return new IntegratedWindowsAuthenticator();
	} else if (protocol === Protocol.ExplicitForms || protocol === Protocol.FormsVariant) {
		return new FormsAuthenticator();
	} else if (
		protocol === Protocol.CitrixAGBasic ||
		protocol === Protocol.CitrixAGBasicNoPassword
	) {
		return new GatewayAuthenticator();
	} else if (protocol === Protocol.Certificate) {
		return new CertificateAuthenticator();
	} else if (protocol === Protocol.HttpBasic) {
		return new HttpBasicAuthenticator();
	}

	throw new Error('Unsupported protocol');
}
